export default "__VITE_ASSET__Ch0unl1z__"